module.exports = __webpack_public_path__ + "static/img/er.9efc159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/er.png
// module id = s0Xb
// module chunks = 0